import Modal from "global/Modal/Modal";
import { useState } from "react";
import { useSelector } from "react-redux";
import { getDay } from "tools/functions/Methods";
import useGetData from "./useGetData";

import { BsCheckCircle, BsXCircle } from "react-icons/bs";
import { 
  FiAlignJustify, 
  FiClock, 
  FiEdit3, 
  FiFileText, 
  FiHelpCircle, 
  FiTarget,
  FiLoader,
  FiUser,
  FiUserCheck
} from "react-icons/fi";
import { Pagination } from 'react-pagination-bar';

const SurveyDetail = ({ open, setOpen, surveyId }) => {
  const [pageTable, setpageTable] = useState(1);

  useGetData(open, surveyId, pageTable);

  const { surveyDetailData, fetchpost } = useSelector(
    (state: any) => state.SurveyDetailSlice
  );

  const data =
    surveyDetailData?.content?.length !== 0
      ? surveyDetailData?.content?.map((item: any) => {
          return {
            ...item,
            isActiveLabel: item.isActive ? "فعال" : "غیرفعال",
            createdDateLabel: getDay(item.createdDate),
            modifiedDateLabel: getDay(item.modifiedDate),
            authorLabel: item.author || "-",
            modifierLabel: item.modifier || "-",
            selectRelatedContentLabel: item.questionContentResponseList?.length > 0
                ? item.questionContentResponseList.map((q: any) => q.title).join("، ")
                : "-",
            selectQuestionLabel: item.selectQuestion?.text || "-",
            selectMainQuestionLabel: item.selectMainQuestion?.text || "-",
          };
        })
      : [];

  return (
    <Modal visible={open} setVisible={setOpen} title="جزئیات نظرسنجی">
      <div className="w-full">
        {fetchpost ? (
          <div className="flex flex-col items-center justify-center py-20 text-brand">
            <FiLoader className="animate-spin mb-4" size={32} />
            <span className="text-sm font-medium text-gray-500">در حال دریافت اطلاعات...</span>
          </div>
        ) : data?.length > 0 ? (
          <div className="grid grid-cols-1 gap-5">
            {data.map((item: any, index: number) => (
              <div
                key={item.id || index}
                className="rounded-3xl border border-gray-100 bg-white p-5 md:p-6 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] transition-all hover:shadow-lg"
              >
                {/* Header */}
                <div className="mb-5 flex flex-col gap-4 border-b border-gray-100 pb-5 md:flex-row md:items-start md:justify-between">
                  <div className="flex items-start gap-4">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-blue-50/80 text-blue-600 shadow-inner">
                      <FiAlignJustify size={22} />
                    </div>
                    <div>
                      <h3 className="text-base font-bold text-gray-800 leading-relaxed">
                        {item.selectQuestionLabel}
                      </h3>
                      <p className="mt-1.5 flex items-center gap-1.5 text-sm font-medium text-gray-500">
                        <FiTarget className="text-gray-400" size={14} />
                        سوال وابسته: <span className="text-gray-700">{item.selectMainQuestionLabel}</span>
                      </p>
                    </div>
                  </div>

                  <div className="shrink-0">
                    <span
                      className={`inline-flex items-center gap-1.5 rounded-xl px-3.5 py-1.5 text-xs font-bold ${
                        item.isActiveLabel === "فعال"
                          ? "bg-emerald-50 text-emerald-700 border border-emerald-100"
                          : "bg-red-50 text-red-700 border border-red-100"
                      }`}
                    >
                      {item.isActiveLabel === "فعال" ? (
                        <BsCheckCircle size={14} />
                      ) : (
                        <BsXCircle size={14} />
                      )}
                      {item.isActiveLabel}
                    </span>
                  </div>
                </div>

                {/* Body / Grid Data */}
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
                  
                  {/* محتوای مرتبط */}
                  <div className="flex items-center gap-3 rounded-2xl bg-gray-50/80 p-3.5 border border-gray-100/50">
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-purple-100/50 text-purple-600">
                      <FiFileText size={16} />
                    </div>
                    <div className="overflow-hidden">
                      <p className="text-[11px] font-medium text-gray-500">محتوای مرتبط</p>
                      <p className="truncate text-sm font-semibold text-gray-800" title={item.selectRelatedContentLabel}>
                        {item.selectRelatedContentLabel}
                      </p>
                    </div>
                  </div>

                  {/* ایجاد کننده */}
                  <div className="flex items-center gap-3 rounded-2xl bg-gray-50/80 p-3.5 border border-gray-100/50">
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-teal-100/50 text-teal-600">
                      <FiUser size={16} />
                    </div>
                    <div className="overflow-hidden">
                      <p className="text-[11px] font-medium text-gray-500">ایجاد کننده</p>
                      <p className="truncate text-sm font-semibold text-gray-800" title={item.authorLabel}>
                        {item.authorLabel}
                      </p>
                    </div>
                  </div>

                  {/* ویرایش کننده */}
                  <div className="flex items-center gap-3 rounded-2xl bg-gray-50/80 p-3.5 border border-gray-100/50">
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-indigo-100/50 text-indigo-600">
                      <FiUserCheck size={16} />
                    </div>
                    <div className="overflow-hidden">
                      <p className="text-[11px] font-medium text-gray-500">ویرایش کننده</p>
                      <p className="truncate text-sm font-semibold text-gray-800" title={item.modifierLabel}>
                        {item.modifierLabel}
                      </p>
                    </div>
                  </div>

                  {/* تاریخ ایجاد */}
                  <div className="flex items-center gap-3 rounded-2xl bg-gray-50/80 p-3.5 border border-gray-100/50">
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-blue-100/50 text-blue-600">
                      <FiClock size={16} />
                    </div>
                    <div>
                      <p className="text-[11px] font-medium text-gray-500">تاریخ ایجاد</p>
                      <p className="text-sm font-semibold text-gray-800">
                        {item.createdDateLabel || "-"}
                      </p>
                    </div>
                  </div>

                  {/* تاریخ آخرین ویرایش */}
                  <div className="flex items-center gap-3 rounded-2xl bg-gray-50/80 p-3.5 border border-gray-100/50">
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gray-200/50 text-gray-600">
                      <FiEdit3 size={16} />
                    </div>
                    <div>
                      <p className="text-[11px] font-medium text-gray-500">تاریخ آخرین ویرایش</p>
                      <p className="text-sm font-semibold text-gray-800">
                        {item.modifiedDateLabel || "-"}
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center rounded-[2rem] border-2 border-dashed border-gray-200 bg-gray-50/50 py-20 text-center">
            <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-sm text-gray-400">
              <FiHelpCircle size={28} />
            </div>
            <p className="text-base font-bold text-gray-700">داده‌ای یافت نشد</p>
            <p className="mt-1 text-sm font-medium text-gray-500">
              هیچ جزئیاتی برای این نظرسنجی ثبت نشده است.
            </p>
          </div>
        )}

        <div className="mt-8 flex justify-center">
          <Pagination
            currentPage={pageTable}
            itemsPerPage={10}
            onPageChange={(pageNumber) => setpageTable(pageNumber)}
            totalItems={surveyDetailData?.totalElements}
            pageNeighbours={2}
            customClassNames={{
              rpbItemClassNameActive: "pagination_style",
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default SurveyDetail;
